import { IA_KEY } from 'helpers/ia-logic';
import { watchColumnActions, PAGE_LAYOUT_VARIANT } from 'features/App';

import Schedules from './SchedulesContainer';
import { AddScheduleForm, EditScheduleForm, EditScheduleInstanceForm } from './ScheduleForm';
import {
  handleRouteEnter,
  watchSchedulesActions,
  doClearScheduleFormState,
  handleEditScheduleRouteEnter,
  handleEditScheduleInstanceRouteEnter,
  handleRouteEnterForm,
} from './Schedules.saga';
import {
  handleClasstivitySchedulerRouteEnter,
  watchClasstivitySchedulerActions,
} from './ClasstivityScheduler/ClasstivityScheduler.saga';

export default [
  {
    path: '/manage/schedule/generate/:venueId/edit-instance/:id',
    component: EditScheduleInstanceForm,
    iaKey: IA_KEY.MANAGE_CLASS_SCHEDULE,
    locationSagas: [],
    pathSagas: [watchSchedulesActions, watchColumnActions, handleRouteEnterForm, handleEditScheduleInstanceRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    isFixedPage: true,
    hasMultipleColumns: false,
  },
  {
    path: '/manage/schedule/generate/:venueId/:startDate/create',
    component: AddScheduleForm,
    iaKey: IA_KEY.MANAGE_CLASS_SCHEDULE,
    locationSagas: [],
    pathSagas: [watchSchedulesActions, watchColumnActions, handleRouteEnterForm, doClearScheduleFormState],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    isFixedPage: true,
    hasMultipleColumns: false,
  },
  {
    path: '/manage/schedule/generate/:venueId/:startDate?/edit/:id',
    component: EditScheduleForm,
    iaKey: IA_KEY.MANAGE_CLASS_SCHEDULE,
    locationSagas: [],
    pathSagas: [watchSchedulesActions, watchColumnActions, handleRouteEnterForm, handleEditScheduleRouteEnter],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    isFixedPage: true,
    hasMultipleColumns: false,
  },
  {
    path: '/manage/schedule/generate/:venueId/:startDate?',
    component: Schedules,
    iaKey: IA_KEY.MANAGE_CLASS_SCHEDULE,
    locationSagas: [handleClasstivitySchedulerRouteEnter],
    pathSagas: [
      watchSchedulesActions,
      watchColumnActions,
      handleRouteEnter,
      handleClasstivitySchedulerRouteEnter,
      watchClasstivitySchedulerActions,
    ],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
    isFixedPage: true,
    hasMultipleColumns: true,
  },
];
